package dev.akshaychordiya.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.akshaychordiya.MetaTextStyle
import dev.akshaychordiya.components.layouts.PageLayoutData
import dev.akshaychordiya.components.widgets.ListRowStyle
import dev.akshaychordiya.components.widgets.PageHeader
import dev.akshaychordiya.content.App
import dev.akshaychordiya.content.PLAY_DEVELOPER_URL
import dev.akshaychordiya.content.apps
import dev.akshaychordiya.fadeIn
import dev.akshaychordiya.fadeUp
import dev.akshaychordiya.toSitePalette
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img

@InitRoute
fun initAppsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Apps"))
}

/** Play Store icons use a 20%-ish corner radius, so matching that keeps them looking native rather than pasted in. */
val AppIconStyle = CssStyle.base {
    Modifier
        .size(3.5.cssRem)
        .flexShrink(0)
        .borderRadius(0.9.cssRem)
        .border(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
}

@Composable
private fun AppRow(app: App, index: Int) {
    val palette = ColorMode.current.toSitePalette()

    Div(ListRowStyle.toModifier().fadeUp(index).toAttrs()) {
        Link(
            path = app.storeUrl,
            variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
        ) {
            Row(Modifier.fillMaxWidth().gap(1.cssRem)) {
                Img(
                    src = app.iconUrl,
                    alt = "${app.name} icon",
                    attrs = AppIconStyle.toModifier().toAttrs(),
                )
                Column(Modifier.fillMaxWidth().gap(0.3.cssRem)) {
                    Row(Modifier.gap(0.6.cssRem).flexWrap(FlexWrap.Wrap)) {
                        SpanText(app.name, ArticleTitleStyle.toModifier())
                        if (app.note.isNotEmpty()) {
                            SpanText(app.note, MetaTextStyle.toModifier().margin(top = 0.25.cssRem))
                        }
                    }
                    SpanText(app.tagline, Modifier.fontSize(0.98.cssRem).color(palette.subdued))
                }
            }
        }
    }
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun AppsPage() {
    PageHeader(
        eyebrow = "On Google Play",
        title = "Apps",
        subtitle = "Things I built for myself and published anyway.",
    )

    Column(Modifier.fillMaxWidth()) {
        apps.forEachIndexed { index, app -> AppRow(app, index) }
    }

    Link(
        PLAY_DEVELOPER_URL,
        "See them all on Google Play",
        RssPillStyle.toModifier().margin(top = 2.cssRem).fadeIn(index = 4),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
    )
}
